module.exports = __webpack_public_path__ + "img/la_rural_seguros.9dbe500b.png";